<template>
  <div v-if="payment.MaintenanceFee">
    <div style="display: flex; align-items: center; justify-content: center; padding-top: 10px; padding-bottom: 25px">
      <span class="title-user-scr">{{ payment.customer.username }}</span>      
    </div>
    <small>{{ payment.MaintenanceFee.concept }}</small><br>
    <small>{{ payment.concept }}</small><br/>

    <div class="text-center" style="margin:30px">
       <span class="title-user-scr">Transferencia o deposito</span>  
    </div>
    <v-form ref="formPago" v-model="validFormPago" lazy-validation v-if="payment">
      <PagoForm ref="editPago" :payment="payment"></PagoForm>    
    </v-form>
    <br />
    <v-btn block color="blue" style="color:white" :disabled="!validFormPago" large rounded @click="payByUser"
      >Enviar información pago</v-btn>
      <br>
      <v-btn block color="blue" large outlined rounded to="/financial" >Cancelar</v-btn>  
  </div>
</template>


<script>

import maintenanceService from '@/services/users/maintenancePayments';
import PagoForm from '../../components/PagoForm.vue';


export default {
  components: { PagoForm },
    props: {
    pagoId: String
    },
  data() {
    return {
      payment: {},
      validFormPago: true,
    };
  },
  created() {
    this.fetchPayment();
  },
  computed: {
   
  },
  methods: {    
    fetchPayment() {        
      maintenanceService.fetchById(this.pagoId).then((response) => {   
        this.payment = response.data;        
      });
    },
   payByUser() {
      if (this.$refs.formPago.validate()) {
        const dataForm = this.$refs.editPago.paymentData();
       
        console.log(console.log(dataForm.payment));
        maintenanceService
          .registerPymtUser(dataForm.id, dataForm.payment)
          .then((res ) => {
            console.log(res);
            this.$swal('Pago registrado', 'El pago está en espera de validacion', 'success');
            this.$router.push('/financial');            
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              this.$swal('Error al registrar pago', error.response.data.message, 'warning');
            }
          });
    }
  }
}};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>